








import {Component, Vue} from 'vue-property-decorator';
import FormLogin from '@v/FormLogin.vue';

@Component({
  components: {
    FormLogin,
  },
})
export default class AuthLayout extends Vue {}
